<template lang="html">
  <div class="input" :class="{ focussed }" @click="focusInput">
    <input
      :placeholder="placeholder"
      ref="inputElement"
      :value="value"
      :type="type"
      @blur="focussed = false"
      @focus="focussed = true"
      @input="$emit('input', $event.target.value)"
      @keyup.enter="confirm"
    >
  </div>
</template>

<script>

export default {
  data() {
    return {
      focussed: false,
    };
  },
  methods: {
    confirm() {
      this.$emit('confirm');
    },
    // focusInput let's me control the CSS when the input is focussed
    focusInput() {
      this.$refs.inputElement.focus();
    },
  },
  props: {
    placeholder: {
      type: String,
      default: 'Type something',
    },
    type: {
      type: String,
      default: 'text',
    },
    value: [String, Number, Date],
  },
};
</script>

<style lang="stylus" scoped>

.input
  border-top: 0.5px solid white
  background-color: transparent
  border-radius: 0px
  display: flex;
  align-items: center
  height:60px
  color: white

  &.focussed
    background-color: white
    color: black
    outline: none
    border-radius: 2px

input
  background-color: transparent
  font-family: inherit
  font-size: 16px
  margin-left: 40px
  margin-right: 16px
  width: 100%
  font-family: futura-pt, sans-serif
  font-weight: 400;
  font-style: normal
  color: white
  text-transform: uppercase
  border:none

  &:focus
    outline: none
    background-color: white
    color: black

.button
  background-color: white
  color: black
  margin-right: 30px
  opacity: 0

.icon
  opacity: 0

// remove spin buttons and calendar
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button
  -webkit-appearance: none
  margin: 0

input[type=number]
  -moz-appearance: textfield

[type="date"]::-webkit-inner-spin-button
  display: none

[type="date"]::-webkit-calendar-picker-indicator
  display: none


</style>
